import React, { useState } from 'react';
import Select from 'react-select';

const RoutingTab = () => {
    return (
        <>
            <form>
                <div className="row border-bottom-2 pb-3">
                    <div className="col-md-12">
                        <div className=" py-2">
                            <table className="table table-sm">
                                <thead>
                                    <tr>
                                        <th className='form-label text-label-red'></th>
                                        <th className='form-label text-label-red'>Mode</th>
                                        <th className='form-label text-label-red'>Type</th>
                                        <th className='form-label text-label-red'>From</th>
                                        <th className='form-label text-label-red'>To</th>
                                        <th className='form-label text-label-red'>ETD</th>
                                        <th className='form-label text-label-red'>ETA (Dest.)</th>
                                        <th className='form-label text-label-red'>Carrier</th>
                                        <th className='form-label text-label-red'>Receipt No</th>
                                        <th className='form-label text-label-red'>Remarks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
                {/* <div className="row justify-content-end mt-3 gap-2">
                    <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e) => { e.preventDefault() }} >
                        Save
                    </button>
                    <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e) => { e.preventDefault() }} >
                        Save & Close
                    </button>
                    <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e) => { e.preventDefault() }} >
                        Save & New
                    </button>
                    <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e) => { e.preventDefault() }} >
                        Close
                    </button>

                </div> */}
            </form>
        </>
    )
}

export default RoutingTab